import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-bold text-background-50 mb-4">
              <i className="ri-camera-lens-line text-primary-400 text-xl"></i>
              <span>自拍指南</span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              最专业的国产自拍技巧教学平台，从手机选购、构图布光到后期修图，手把手教你用国产设备拍出专业级自拍效果。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-secondary-400 hover:text-background-50 transition-colors">首页</Link>
              <Link to="/about" className="text-sm text-secondary-400 hover:text-background-50 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#categories" className="hover:text-primary-400 transition-colors">内容分类</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-secondary-400 hover:text-background-50 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <div className="flex flex-col gap-2.5 text-sm text-secondary-400">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                hello@selfie-guide.cn
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                中国 · 深圳
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; {new Date().getFullYear()} 自拍指南. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#privacy" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#terms" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}